import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import FreeGameJoinPage from '~/play/join/FreeGameJoinPage';

export const Route = createFileRoute('/freegames/$id/join')({
  component: FreeGameJoinRoute,
});

function FreeGameJoinRoute() {
  const { id } = Route.useParams();
  return <FreeGameJoinPage id={id} />;
}
